import { Route } from "@angular/router";

export const DocumentsPaths = {
  List: "",
  Templates: "sjablonen",
  AddTemplate: "sjabloon/toevoegen",
  EditTemplate: (id: number | string) => `sjabloon/bewerken/${id}`,
  Add: (personId: number | string) => `${personId}/toevoegen`,
  Edit: (id: number | string) => `${id}/bewerken`,
};

export default [
  {
    path: DocumentsPaths.List,
    loadComponent: () =>
      import("../menu/pages/on-hold/on-hold.component").then((c) => c.OnHoldComponent),
    data: {
      breadcrumb: "Documenten",
      title: "Documenten",
      subscriptionTypes: [1],
    },
  },
  {
    path: DocumentsPaths.Templates,
    loadComponent: () =>
      import("./pages/document-template-list/document-template-list.component").then(
        (c) => c.DocumentTemplateListComponent
      ),
    data: {
      breadcrumb: "Sjablonen voor documenten",
      title: "Sjablonen voor documenten",
      subscriptionTypes: [1],
    },
  },
  {
    path: DocumentsPaths.AddTemplate,
    loadComponent: () =>
      import("./pages/document-template-edit/document-template-edit.component").then(
        (c) => c.DocumentTemplateEditComponent
      ),
    data: {
      breadcrumb: "Sjabloon voor afsprakennota",
      title: "Sjabloon voor afsprakennota",
      subscriptionTypes: [1],
    },
  },
  {
    path: DocumentsPaths.EditTemplate(":id"),
    loadComponent: () =>
      import("./pages/document-template-edit/document-template-edit.component").then(
        (c) => c.DocumentTemplateEditComponent
      ),
    data: {
      breadcrumb: "Sjabloon voor afsprakennota bewerken",
      title: "Sjabloon voor afsprakennota bewerken",
      subscriptionTypes: [1],
    },
  },
  {
    path: DocumentsPaths.Add(":personId"),
    loadComponent: () =>
      import("./pages/document-edit/document-edit.component").then((c) => c.DocumentEditComponent),
    data: {
      breadcrumb: "Afsprakennota toevoegen",
      title: "Afsprakennota toevoegen",
      subscriptionTypes: [1],
    },
  },
  {
    path: DocumentsPaths.Edit(":id"),
    loadComponent: () =>
      import("./pages/document-edit/document-edit.component").then((c) => c.DocumentEditComponent),
    data: {
      breadcrumb: "Afsprakennota bewerken",
      title: "Afsprakennota bewerken",
      subscriptionTypes: [1],
    },
  },
] satisfies Route[];
